import { Outlet } from 'react-router-dom';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import utc from 'dayjs/plugin/utc';
import { AppThemeProvider } from '@cbridge-modules/toolpad-core';
import { createTheme } from '@cbridge-utils/mui-theme';
import { DialogsProvider } from '@cbridge-modules/dialog';
import { Notifications } from '@cbridge-modules/notification';
import { AppLayout } from './layouts/AppLayout';
import 'simplebar-react/dist/simplebar.min.css';
import 'dockview-react/dist/styles/dockview.css';

export default function App() {
  dayjs.extend(duration);
  dayjs.extend(utc);

  return (
    <AppThemeProvider theme={createTheme(true)}>
      <DialogsProvider>
        <AppLayout>
          <Outlet />
        </AppLayout>
        <Notifications />
      </DialogsProvider>
    </AppThemeProvider>
  );
}
